import * as contentRange from "content-range";

class SalesResource {
    public static $inject: string[] = ["$resource", "configService"];

    constructor($resource: ng.resource.IResourceService, { gatewayApi }) {
        const apiUrl = `${gatewayApi.url}/v1/sales/:id`;

        return (headers: any = {}) =>
            $resource(
                apiUrl,
                { id: "@id", auctionType: "@auctionType" },
                {
                    countSubscriptions: {
                        method: "HEAD",
                        url: `${apiUrl}/:auctionType/subscriptions`,
                        headers,
                        transformResponse: (_, headersGetter) => {
                            const range = contentRange.parse(headersGetter("Content-Range"));
                            return { count: range && range.length };
                        }
                    }
                }
            );
    }
}

class LiveSalesResultsResource {
    public static $inject: string[] = ["$resource", "configService"];

    constructor($resource: ng.resource.IResourceService, { gatewayApi }) {
        return () => $resource(`${gatewayApi.url}/v1/sales/:id/salesresults`, { id: "@id" });
    }
}

angular
    .module("thor.core.gateway-api.resource", [])
    .factory("salesResource", SalesResource)
    .factory("liveSalesResultsResource", LiveSalesResultsResource);
